import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    VehicleTypeResponse,
    CreateVehicleTypeBody,
    createVehicleType,
    UpdateVehicleTypeBody,
    updateVehicleType,
} from '../../services/apiSLTP/materials/vehiclesTypes';

type UseUpdateVehicleTypeMutationOptions = MutationOptions<VehicleTypeResponse, Error, { vehicleTypeId: string; data: UpdateVehicleTypeBody }>;

type UseCreateVehicleTypeMutationOptions = MutationOptions<VehicleTypeResponse, Error, CreateVehicleTypeBody>;

export const useUpdateVehicleTypeMutation = (options?: UseUpdateVehicleTypeMutationOptions) => {
    const vehicleTypeMutation: MutationFunction<VehicleTypeResponse, { vehicleTypeId: string; data: UpdateVehicleTypeBody }> = async ({
        vehicleTypeId,
        data,
    }) => {
        try {
            const response: VehicleTypeResponse = await updateVehicleType(vehicleTypeId, data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during vehicleType update');
        }
    };

    return useMutation(vehicleTypeMutation, options);
};

export const useCreateVehicleTypeMutation = (options?: UseCreateVehicleTypeMutationOptions) => {
    const vehicleTypeMutation: MutationFunction<VehicleTypeResponse, CreateVehicleTypeBody> = async (data) => {
        try {
            const response: VehicleTypeResponse = await createVehicleType(data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during vehicleType creation');
        }
    };

    return useMutation(vehicleTypeMutation, options);
};
